/**
 * Ksting
 *
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, shape, string, array } from 'prop-types';
import classNames from 'clsx';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Select from 'components/Form/Input/Select/Select';

import styles from './language-switch.scss';

import Globe from 'gfx/vector/globe-icon.svg';

/**
 * This is the LanguageSwitch component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Pelle Lundgren <pelle.lundgren@vntrs.com>
 */
export class LanguageSwitch extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    location: object.isRequired,
    app: shape({
      locale: string.isRequired,
    }).isRequired,
    bootstrap: shape({
      pages: array.isRequired,
      languages: object.isRequired,
    }).isRequired,
  };

  onChange = event => {
    const code = event.target.value;

    this.switchLanguage(code);
  };

  switchLanguage = code => {
    const {
      location: { pathname },
      app: { locale },
      bootstrap: { pages },
    } = this.props;

    // get current page URL without the locale.
    const pageSlug = window.location.pathname.replace(`/${locale}`, '');
    const currentPage = pages.find(page => page.aliases.includes(pageSlug));
    const { hreflangs } = currentPage || {};

    // if current page URL has hreflangs.
    if (hreflangs) {
      // find the right URL to change to.
      const { href } = hreflangs.find(({ hreflang }) => hreflang === code);

      window.location.href = href;
    } else if (pathname.includes('news')) {
      const newsPageUrl = window.location.pathname.replace(locale, code);

      window.location.href = newsPageUrl;
    } else {
      window.location.href = `/${code}`;
    }
  };

  renderMenu() {
    const {
      app: { locale },
      bootstrap: { languages },
    } = this.props;
    const total = languages.length - 1;

    return Object.keys(languages).map((key, i) => {
      return (
        <li key={key}>
          <button
            className={classNames(styles.languageButton, {
              [styles.active]: key === locale,
            })}
            onClick={() => this.switchLanguage(key)}
          >
            {languages[key]}
            {total === i && <span className={styles.arrow} />}
          </button>
        </li>
      );
    });
  }

  /**
   * Render LanguageSwitch.
   *
   * @return {Object}
   */
  render() {
    const {
      app: { locale },
      bootstrap: { languages },
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <Globe className={styles.label} />
        <div className={styles.select}>
          <Select
            small
            transparent
            name="language"
            value={locale}
            options={languages}
            onChange={this.onChange}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(({ app, bootstrap }) => ({ app, bootstrap }))(LanguageSwitch)
);
